// extracted by mini-css-extract-plugin
export default {"cell":"styles-module__cell__src-labstep-web-grid-Index-coldefs-Entity-actionMenu-_HbHbb"};